import { HTMLAttributes } from 'react';
import { styled } from '~ui-kit/styled-components';
import {
  styledBorders,
  StyledBordersProps,
  styledChildPositioning,
  StyledChildPositioningProps,
  styledColoring,
  StyledColoringProps,
  styledGridLayout,
  StyledGridLayoutProps,
  styledSelfPositioning,
  StyledSelfPositioningProps,
  styledSizing,
  StyledSizingProps,
  styledSpace,
  StyledSpaceProps,
} from '~ui-kit/theme/styled-system';

export interface GridProps
  extends HTMLAttributes<HTMLDivElement>,
    StyledColoringProps,
    StyledGridLayoutProps,
    StyledSpaceProps,
    StyledChildPositioningProps,
    StyledSelfPositioningProps,
    StyledBordersProps,
    StyledSizingProps {}

export const Grid = styled.div<GridProps>`
  display: grid;
  position: relative;

  ${styledGridLayout}
  ${styledColoring}
  ${styledSizing}
  ${styledSpace}
  ${styledBorders}
  ${styledChildPositioning}
  ${styledSelfPositioning}
`;
